import { Segment } from '../../../../services/analytics-services/segment';
import { useCallback } from 'react';
import { useSellerOnboardingVariant } from '../../../../hooks/use-seller-setting';

export const useSegmentTracking = (event) => {
  const onboardingVariant = useSellerOnboardingVariant();
  return useCallback(() => {
    const params = {
      onboardingVariant,
    };
    setTimeout(() => Segment.trackEvent(event, params), 0);
  }, [event, onboardingVariant]);
};
